import React from 'react';
import cls from 'classnames';
import { SkeletonProps } from './Skeleton.type';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

export const classNames = getClassNames('sds-skeleton');

const Skeleton: React.FC<SkeletonProps> = (props) => {
	const { className } = props;

	return (
		<div className={cls(getRootClassListFromProps(classNames, props), className)}>
			&nbsp;
		</div>
	);
};

Skeleton.displayName = 'Skeleton';

export default Skeleton;
